export default "https://cdn-static.gokick.com/assets/31bbee86f9627d9d8b331552e0c9ca66f3d2b554/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";